import React from "react";
import { observer, inject } from "mobx-react";
import { CallbackFixed } from "ComponentsUI/SideWidgets";
import Metrika from "Services/Metrika";
import {
    CLICK_OPEN_WIDGET,
    CLICK_CLOSE_WIDGET,
} from "Constants/metriks/Yandex";
import { EVENT_ACTION_CLICK_WAIT_CALL } from "Constants/metriks/GoogleActions";
import { SELECT_CALLBACK_FIELD_PHONE } from "Constants/metriks/Yandex";
import { CallbackBase } from "Overlays/Callback";
import userInfo from "Services/UserInfo";

@CallbackBase
@inject("ApplicationModel")
@observer
export default class CallbackFixedContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phone_connection: "",
            error: false,
        };
    }

    openWindow() {
        let fixedModel = this.props.ApplicationModel.fixedPanelModel;
        fixedModel.openCallback();
    }

    openAddReview() {
        let fixedModel = this.props.ApplicationModel.fixedPanelModel;
        fixedModel.openAddReview();
    }

    closeWindow() {
        let fixedModel = this.props.ApplicationModel.fixedPanelModel;
        this.setState({
            error: false,
            phone_connection: "",
        });
        fixedModel.closeCallback();
    }

    async sendOrder(e) {
        if (!!e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let {
            ApplicationModel: {
                sendingStore,
                searcheModel,
                currentRegion,
                popupModel,
            },
        } = this.props;
        let data = {
            phone_connection: this.state.phone_connection,
            region_id: !!currentRegion ? currentRegion.id : null,
            lead_form_type: userInfo(EVENT_ACTION_CLICK_WAIT_CALL),
        };

        if (searcheModel.getCurrentAddress()) {
            let address = searcheModel.getCurrentAddress();
            let street = searcheModel.getCurrentStreet();
            data.street_id = street.id;
            data.house_id = address.id;
        }

        let infoUser = {
            name_popup: "CallBackFixed"
        }
        popupModel.setInfoUser(infoUser)

        let error = await sendingStore.onCallback(data);
        if (!error) {
            this.props.onSendOrder(data);
        } else {
            this.setState({
                error: error,
            });
        }
    }

    changePhoneConnection(e) {
        this.setState({
            phone_connection: e.target.value,
        });
    }

    onFocusPhoneHandler() {
        this.setState({
            error: false,
        });
    }

    onBlur() {
        this.setState({
            error:
                this.state.phone_connection.length !== 11 &&
                this.state.phone_connection.length !== 1,
        });
    }

    render() {
        let {
            ApplicationModel: { commonViewModel, fixedPanelModel, text },
            isSend,
        } = this.props;
        let errorText = "";

        let callbackSended = commonViewModel.callbackSended;
        if (this.state.error) {
            errorText = text.CALLBACK_ERROR;
        }
        return null;
        return (
            <React.Fragment>
                <CallbackFixed
                    text={text}
                    typeB={true}
                    openWindow={() => this.openWindow()}
                    closeWindow={() => this.closeWindow()}
                    openAddReview={() => this.openAddReview()}
                    sendOrder={e => this.sendOrder(e)}
                    changePhoneConnection={event =>
                        this.changePhoneConnection(event)
                    }
                    phone={this.state.phone_connection}
                    error={errorText}
                    //callbackSended={callbackSended}
                    callbackSended={callbackSended}
                    isOpen={fixedPanelModel.callbackIsOpen}
                    onFocusPhone={() => this.onFocusPhoneHandler()}
                    onBlurPhone={() => this.onBlur()}
                />
            </React.Fragment>
        );
    }
}
